import { EnvioGraphQLClient } from '@peeramid-labs/sdk';
import { gql } from 'graphql-request';

export interface LastBlockResponse {
  blockNumber: string;
  blockTimestamp: string;
}

interface EventSyncState {
  block_number: string;
  block_timestamp: string;
}

interface GraphQLResponse {
  event_sync_state: EventSyncState[];
}

/**
 * Gets the last block number and timestamp from the Envio indexer
 * @param envioClient - The Envio GraphQL client instance
 * @returns Promise with the last block number and timestamp
 */
export async function getLastBlock(envioClient: EnvioGraphQLClient): Promise<LastBlockResponse> {
  const query = gql`
    query GetLastBlock {
      event_sync_state(limit: 1) {
        block_number
        block_timestamp
      }
    }
  `;

  try {
    const response = await envioClient.client.request<GraphQLResponse>(query);
    const lastBlock = response.event_sync_state[0];

    if (!lastBlock) {
      throw new Error('No blocks found in the indexer');
    }

    return {
      blockNumber: lastBlock.block_number,
      blockTimestamp: lastBlock.block_timestamp,
    };
  } catch (error) {
    console.error('Error fetching last block:', error);
    throw error;
  }
}

export async function waitForBlockAndInvalidate(
  envioClient: EnvioGraphQLClient,
  blockNumber: number,
  onSynced: () => void
): Promise<LastBlockResponse> {
  if (isNaN(blockNumber) || blockNumber < 0) {
    throw new Error('Block number is not a number');
  }
  while (true) {
    const lastBlock = await getLastBlock(envioClient);
    if (parseInt(lastBlock.blockNumber, 10) >= blockNumber) {
      onSynced();
      return lastBlock;
    }
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
}
